import {
  bootstrapApplication,
  Meta,
  provideClientHydration
} from "@angular/platform-browser";
import {
  APP_INITIALIZER,
  PLATFORM_ID,
  importProvidersFrom,
  provideZoneChangeDetection
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideServerRendering } from "@angular/platform-server";
import { provideRouter, Router, withInMemoryScrolling } from "@angular/router";
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  HttpRequest
} from "@angular/common/http";
import { DatePipe, isPlatformBrowser } from "@angular/common";
import { JwtHelperService, JWT_OPTIONS } from "@auth0/angular-jwt";

import { NgxPermissionsModule } from "ngx-permissions";
// import { NgxSpinnerModule } from "ngx-spinner";
import { BlockUIModule } from "ng-block-ui";
import { BlockUIHttpModule } from "ng-block-ui/http";
import { ToastrModule } from "ngx-toastr";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule } from "@angular/material/dialog";

import { AppComponent } from "src/app/app.component";
import { AuthInterceptor } from "src/app/Authentication/interceptors/auth.interceptor";
import { InitializationService } from "src/utils/initialization.service";
import { initializeApp } from "src/utils/initialization.factory";
import { RoleService } from "src/app/Authentication/services/role.service";
import { APP_ROUTES } from "src/app/app-routes";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

function BlockUIFilterFunction(req: HttpRequest<any>) {
  return /Notification\/\d+\/count$/.test(req.urlWithParams);
}

export function bootstrapApp() {
  return bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(APP_ROUTES, withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideServerRendering(),
      provideClientHydration(),
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi(), withFetch()),

      importProvidersFrom(
        ToastrModule.forRoot({ preventDuplicates: true }),
        MatSnackBarModule,
        MatDialogModule,
        // NgxSpinnerModule,
        NgxPermissionsModule.forRoot(),
        BlockUIModule.forRoot(),
        BlockUIHttpModule.forRoot({
          requestFilters: [BlockUIFilterFunction]
        }),
        NgxDaterangepickerMd.forRoot(),
        NgxSkeletonLoaderModule.forRoot({
          theme: {
            extendsFromRoot: true,
            height: '30px',
          },
        })
      ),

      DatePipe,

      Meta,

      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },

      {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [
          InitializationService,
          Router,
          RoleService,
          PLATFORM_ID
        ],
        multi: true
      },

      {
        provide: JwtHelperService,
        deps: [PLATFORM_ID],
        useFactory: (platformId: Object) =>
          isPlatformBrowser(platformId)
            ? new JwtHelperService()
            : ({} as JwtHelperService)
      },
      { provide: JWT_OPTIONS, useValue: {} }
    ]
  });
}
